import { useCallback } from "react"
import { useGlobalContext } from "../context/useGlobalContext"
import { useProfile } from "./useTypeProfile";
import { getPointsData, getPositionHost, getRankingHostGlobal, getRankingHostLocal, getRankingHostResto } from "../services/transactionService"
import { useUser } from "./useUser";

export const useTransaction = () => {
    const { points, setPoints, pointsLoader, setPointsLoader, ranking, setRanking, hostPosition, setHostPosition, rankingLoader, setRankingLoader } = useGlobalContext();
    const { getTypeRole } = useProfile();
    const { isCEO } = useUser()
    const profile = getTypeRole();

    const getPoints = useCallback(async () => {
        if (!isCEO) {
            setPointsLoader(true);
            const res = await getPointsData(profile);
            setPoints(res);
            setPointsLoader(false);
        }
    }, [profile, setPoints, setPointsLoader])

    const getRanking = useCallback(async (type = "resto") => {
        try {
            setRankingLoader(true);
            if (type === "resto") {
                await getRankingDataResto()
            }
            if (type === "local") {
                await getRankingDataLocal()
            }

            if (type === "global") {
                await getRankingDataGlobal()
            }
            setRankingLoader(false);
        } catch (error) {
            // Error silenciado - el loader se desactiva
        }

    }, [setRankingLoader])

    const getRankingDataResto = useCallback(async () => {
        const res = await getRankingHostResto();
        setRanking(res);
        return res;
    }, [setRanking])

    const getRankingDataLocal = useCallback(async () => {
        const res = await getRankingHostLocal();
        setRanking(res);
        return res;
    }, [setRanking])

    const getRankingDataGlobal = useCallback(async () => {
        const res = await getRankingHostGlobal();
        setRanking(res);
        return res;
    }, [setRanking])

    const getHostPosition = useCallback(async () => {
        const res = await getPositionHost();
        setHostPosition(res);
        return res
    }, [setHostPosition])

    return {
        ranking,
        rankingLoader,
        hostPosition,
        points,
        pointsLoader,
        getPoints,
        getRanking,
        getHostPosition
    }
}
